window.zh_CN_dic = {
    'plan':'计划',
    'common.calendar.january': '一月',
    'common.calendar.february': '二月',
    'common.calendar.march': '三月',
    'common.calendar.april': '四月',
    'common.calendar.may': '五月',
    'common.calendar.june': '六月',
    'common.calendar.july': '七月',
    'common.calendar.august': '八月',
    'common.calendar.september': '九月',
    'common.calendar.october': '十月',
    'common.calendar.november': '十一月',
    'common.calendar.december': '十二月',
    'common.calendar.sunday.short': '日',
    'common.calendar.monday.short': '一',
    'common.calendar.tuesday.short': '二',
    'common.calendar.wednesday.short': '三',
    'common.calendar.thursday.short': '四',
    'common.calendar.friday.short': '五',
    'common.calendar.saturday.short': '六',
    'common.label.roomCount': '房间',
    'common.label.mailAddressEmptyError': '请输入您的电子邮件地址。',
    'common.label.mailAddressCharacterCountError': '请在 254 个字符内输入您的电子邮件地址。',
    'common.label.mailAddressIncorrectError': '请输入正确的电子邮件地址。',
    'GCER001F00100.label.countryCodeEmptyError': '请输入您的联系信息（国家代码）。',
    'GCER001F00100.label.countryCodeCharacterCountError': '请在 5 个字符内输入联系信息（国家代码）。',
    'GCER001F00100.label.countryCodeIncorrectError': '请输入正确的联系信息（国家代码）。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin5': '请输入5个字符以内的联系方式（区号）。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin9': '请输入9个字符以内的联系方式（区号）。',
    'common.label.areaCodeIncorrectError': '请输入正确的联系方式（区号）。',
    'common.label.cityCodeCharacterCountErrorWithin4': '请在 4 个字符内输入联系信息（城市代码）。',
    'GCER001F00100.label.cityCodeCharacterCountErrorWithin9': '请在 9 个字符内输入联系信息（城市代码）。',
    'common.label.cityCodeIncorrectError': '请输入正确的联系方式（城市代码）。',
    'common.label.subscriberNumberCharacterCountErrorWithin4': '请输入 4 个字符以内的联系信息（订阅者号码）。',
    'GCER001F00100.label.subscriberNumberCharacterCountErrorWithin9': '请输入 9 个字符以内的联系信息（订阅号）。',
    'common.label.subscriberNumberIncorrectError': '请输入正确的联系信息（订户号码）。',
    'GCER001F00100.label.areaCodeEmptyError': '请输入您的联系信息（区号）。',
    'GCER001F00100.label.cityCodeEmptyError': '请输入联系方式（城市代码）。',
    'GCER001F00100.label.subscriberNumberEmptyError': '请输入您的联系信息（订户号码）。',
    'common.label.reservationNumberEmptyError': '请输入您的预订号码。',
    'common.label.reservationNumberCharacterCountError': '请在 19 个字符内输入预订编号。',
    'common.label.passwordEmptyError': '请输入您的密码。',
    'common.label.passwordCharacterCountError': '输入最多 64 个字符的密码。',
    'common.label.authenticationError': '执行身份验证时出错。请重新加载身份验证屏幕并再次执行身份验证。',
    'common.label.snsAuthenticationFail':'SNS 身份验证失败。',
    'GCER001F00100.label.failSnsLogin': '登录 SNS 失败。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin3': '请输入3个字符以内的联系方式（区号）。',
    'common.label.unexpectedLoginError': '登录时发生意外错误。',
    'common.label.sun': '日',
    'common.label.mon': '一',
    'common.label.tue': '二',
    'common.label.wed': '三',
    'common.label.thu': '四',
    'common.label.fri': '五',
    'common.label.sat': '六',
    'common.label.gender.male': '男士',
    'common.label.gender.female': '女士',
    'common.label.gender.other': '其他',
    'common.label.adult':'成人',
    'common.label.guestCount': '人',
    'common.label.comma': '、',
    'common.label.others':'其他',
    'common.label.yen': '日元',
    'common.label.paymentFailMessage': '支付失败。请联系您的系统管理员。',
    'common.label.mailAddressIncorrectFormatError': '请以正确的电子邮件地址格式输入您的电子邮件地址。',
    'common.label.welcomeInformation1-1': '欢迎电子邮件是提醒您的电子邮件',
    'common.label.welcomeInformation1-2': '您入住前一周的预订。',
    'common.label.welcomeInformation2': '* 但是，类似的电子邮件将在您入住前 3 天发送。',
    'common.label.welcomeInformation3': '请注意，您的电子邮件将始终发送给您。',
    'common.label.thankYouInformation': '感谢电子邮件是您入住后发送的电子邮件。',
    'common.label.chargeDetails': '收费详情',
    'common.label.nightNumber': '晚',
    'common.label.roomNumber': '房间',
    'common.label.memberDiscount': '会员折扣',
    'common.label.subtotal': '小计',
    'common.label.totalRoomRate': '总额',
    'common.label.pointYenEquivalent': '积分',
    'common.label.pointBalanceAmount': '可用积分',
    'common.label.usableMaxLimit.point': '使用上限为{0}点',
    'common.label.usableMinLimit.point': '使用下限为{0}点',
    'common.label.usableRange.point': '可使用{0}-{1}积分。',
    'common.label.usableUnit.point': '(使用单位为{0}点)',
    'common.label.usableUnit.point.help': '可以{0}点为单位使用。',
    'common.label.pointToGrantSuffix.point': '{0} 积分',
    'common.label.use': '使用',
    'common.label.useAll': '全部使用',
    'coupon.message.applyCode' : '额外优惠券。',
    'coupon.message.getCoupon' : '得到一张优惠券。',
    'coupon.message.getCoupon.failed' : '无法获得优惠券。',
    'GRES006F02600.label.lodgingNumChangeCautionWord': '* 人数不能加。如果您想添加它，请再次预订。',
    'GRES006F02600.label.lodgingNumPriceEmptyCautionWord': '不能接受您指定的客人总数的预订。',
    'GRES006F02600.label.lodgingDateNumChangeCautionWord': '* 您不能增加住宿天数。如果您想增加它，请再次预订。',
    'GRES006F02600.label.optionChangeWord': '*无法选择，因为它超出了预订接受期限',
    'GRES006F02600.label.kanaInformation': '请输入平假名。',
    'GRES006F02600.label.mailInformation1': '请在两个地方输入相同的电子邮件地址以防止输入错误。',
    'GRES006F02600.label.mailInformation2': '如果您输入您的移动电子邮件地址，请注意您的电子邮件过滤器设置。',
    'GRES006F02600.label.mailInformation3': '如果您设置为无法接收来自互联网的电子邮件，您将无法收到确认预订的电子邮件。',
    'GRES006F02600.label.contactInformation':'请只输入半角数字。',
    'common.label.addressZipMark': '',
    'GRES015F04300.label.reservationAcceptanceSuspension':'抱歉。目前，我们不接受预订。',
    'GRES015F04300.label.planAcceptanceSuspension': '抱歉。目前，我们不接受指定的计划。',
    'GRES015F04300.label.roomAcceptanceSuspension': '抱歉。目前，指定房间的接待处已关闭。',
    'GRES001F02100.label.returnPlanList' : '返回计划列表',
    'GRES001F02100.validation.emptyNameError' : '你的名字是一个必填字段。请输入。',
    'GRES001F02100.validation.wrongNameError' : '请输入除特殊记号，环境依存文字以外的字符。',
    'GRES001F02100.validation.emptyNameKanaError' : '',
    'GRES001F02100.validation.wrongNameKanaError' : '',
    'GRES001F02100.validation.emptyMailAddressError' : '电子邮件地址为必填字段。',
    'GRES001F02100.validation.wrongMailAddressError' : '请以有效格式输入。',
    'GRES001F02100.validation.emptyMailAddressConfirmError' : '电子邮件地址为必填字段。请输入。',
    'GRES001F02100.validation.unmatchMailAddressConfirmError' : '请输入一致的邮件地址信息。',
    'GRES001F02100.validation.emptyTelError' : '电话号码为必填字段。请输入半角数字。',
    'GRES001F02100.validation.wrongTelError' : '请输入半角数字。',
    'GRES001F02100.validation.tooShortTelAreaError' : '请输入2到5个单字节数字的区号。',
    'GRES001F02100.validation.tooLongTelError' : '请输入7到15个单字节数字。',
    'GRES001F02100.validation.emptyLodgerGender' : '性别为必填字段。',
    'GRES001F02100.validation.emptyPassword' : '密码为必填字段。需由8至64位半角字母及数字组成（包括大写和小写字母）',
    'GRES001F02100.validation.wrongPassword' : '需由8至64位半角字母及数字组成（包括大写和小写字母）',
    'GRES001F02100.validation.emptyBirthday' : '出生日期为必填字段。',
    'GRES001F02100.validation.notRequiredEmptyBirthday' : '请选择您的出生日期。',
    'GRES001F02100.validation.emptyZipCode' : '邮政编码是必填字段。请输入单字节数。',
    'GRES001F02100.validation.wrongZipCode' : '请输入单字节数。',
    'GRES001F02100.validation.emptyAddressPrefectures' : '地址为必填字段。',
    'GRES001F02100.validation.emptyAddress' : '地址为必填字段。请输入。',
    'GRES001F02100.validation.emptyCreditCardNo' : '信用卡号码为必填字段。请输入14-16位半角数字。',
    'GRES001F02100.validation.wrongCreditCardNo' : '请输入14-16位半角数字。',
    'GRES001F02100.validation.emptySecurityCode' : '安全码为必填字段。请输入3或4位半角数字。',
    'GRES001F02100.validation.wrongSecurityCode' : '请输入3或4位半角数字。',
    'GRES001F02100.validation.emptyCreditCardName' : '持卡人名称为必填字段。',
    'GRES001F02100.validation.wrongCreditCardName' : '请输入有效的持卡人名称信息。',
    'GRES001F02100.validation.emptyCreditCardExpire' : '信用卡到期日为必填字段。',
    'GRES001F02100.validation.wrongCreditCardExpire' : '将会选择过去的日期。请选择一个将来的日期。',
    'GRES001F02100.validation.tooLongTextArea' : '请输入200个字符以内。',
    'GRES001F02100.validation.emptyContractCompany' : '此栏为必填项。请输入。',
    'GRES001F02100.validation.emptyContractCompanyPassword' : '密码为必填字段。请输入。',
    'GRES001F02100.validation.wrongContractCompanyPassword' : '请输入半角字母数字符号。',
    'GRES001F02100.validation.unmatchLodgerGender' : '请保证选择的人数与预约人数相一致。',
    'GRES001F02100.validation.emptyQuestionTextAnswer' : '此栏为必填项。请输入。',
    'GRES001F02100.validation.tooLongQuestionTextAnswer' : '请输入200个字符以内。',
    'GRES001F02100.validation.emptyQuestionSelectAnswer' : '必须填写。 请选择。',
    'GRES001F02100.validation.emptyQuestionCheckboxAnswer' : '必须填写。 请选择。',
    'GRES001F02100.validation.couponCodeError' : '找不到输入代码的优惠券。 请确认输入的内容。',
    'GRES001F02100.validation.couponCodeDuplicatedError' : '优惠券已经添加。',

    'coupon.label.more': '更多信息▼',
    'coupon.label.close': '更多信息▲',

    'coupon.banner.title.member': '注册成为会员，',
    'coupon.banner.title': '用折扣优惠券省钱!',
    'coupon.banner.title.button': '欲了解更多信息 ▶',
    'coupon.modal.title': '注册成为会员，可享受特别优惠券',
    'coupon.modal.title.member': '正在分发的优惠券清单',
    'coupon.modal.caution': '每张优惠券都有自己的获取和使用条件。',
    'coupon.modal.desc.1': '优惠券的折扣适用于房费。折扣不适用于额外的可选费用。',
    'coupon.modal.desc.2': '你所获得的优惠券会在预订时自动应用于最佳交易和组合。',
    'coupon.modal.desc.3': '如果计划发放的优惠券数量结束，或由于预算或其他原因，优惠券可能提前结束。',
    'coupon.modal.desc.4': '根据预订的时间，即使已经获得，也可能无法使用。',
    'coupon.modal.membership': '如果你已经注册了',
    'coupon.modal.memberLogin': '请登录',
    'coupon.modal.memberRegister': '注册成为会员',
    'coupon.modal.has.otherCoupons': '可在其他日期使用的优惠券',
    'coupon.badge.couponTarget': '优惠券的使用资格',
    'coupon.badge.banner.title': '赚取省钱的优惠券',

    'coupon.label.code': '（{{code}}）',
    'coupon.label.discountAmount.upper': '从预订的总金额中扣除',
    'coupon.label.discountAmount.upper_false': '每人或每间房',
    'coupon.label.discountAmount': '{{amount, number}}日元的折扣',
    'coupon.label.discountAmount_rate': '{{amount, number}}％折扣',
    'coupon.label.discountAmount.has.zeroDiscount': '优惠',
    'coupon.label.canUseTogether_true': '可与其他优惠券一起使用',
    'coupon.label.canUseTogether_false': '不可与其他优惠券同时使用',
    'coupon.label.discountLimit': '最高折扣为{{amount, number}}日元。',
    'coupon.label.discountLimit_plan': '最高折扣为每人每晚{{amount, number}}日元。',
    'coupon.label.fromTotalBookings.not': '* 根据不同的计划，折扣来自于每人每晚的房价或每间房每晚的房价。',
    'coupon.label.useQuantityLimit': '先到先得使用{{amount, number}}张为止',
    'coupon.label.targetPlans': '合格的计划：',
    'coupon.label.availableMonths': '自获得之日起{{months}}个月',
    'coupon.label.expiredAt': '过期日期:',
    'coupon.label.neverExpires': '无有效日期',
    'coupon.label.stayAt': '住宿所涵盖的时期：',
    'coupon.label.periodRange': '{{- day.start}}～{{- day.end}}',
    'coupon.label.periodRangeCheck': '{{- day.start}}报到～{{- day.end}}退房',
    'coupon.label.unavailableDays': '不包括的日子：',
    'coupon.label.unavailablePeriod': '排除期:',
    'coupon.label.useCondition': '可用于{{amount, number}}日元以上的预订',
    'coupon.label.remainingTimes': '最多可以使用{{amount, number}}次（剩余{{remains, number}}次）',
    'coupon.label.remainingTimes.limit': '最多可以使用{{amount, number}}次',
    'coupon.label.remainingTimes.one': '仅有一次机会',
    'coupon.label.remainingTimes.noLimit': '只要你愿意，可以多次使用',
    'coupon.label.acquired': '已经获得',
    'coupon.label.acquiring': '获得',
    'coupon.message.unable.useAmountLimit' : '由于竞选活动已经结束，所以无法获得。',
    'coupon.message.unable.useQuantityLimit' : '由于竞选活动已经结束，所以无法获得。',
    'coupon.message.unable.ended' : '由于竞选活动已经结束，所以无法获得。',
    'coupon.message.unable.notApplied' : '不能与预定使用的优惠券一起使用。',

    'common.message.temporaryError': '发生临时错误。 请重新加载页面以刷新。',
    'common.label.required': '必须',
};
